const REACT_APP_API = process.env.REACT_APP_API_URL;
const API_URL = `${REACT_APP_API|| ""}/api/suggestion_sugs`

export async function getCommunications(url = API_URL) {
  const res = await fetch(url);
  const data = await res.json();
    return data;
}

// Charge une suggestion complète (avec relations) pour l'édition
export async function getSuggestion(id) {
  const res = await fetch(`${API_URL}/${id}`);
  return await res.json();
}

// Liste légère de toutes les suggestions (endpoint dédié) pour traitement côté client
export async function getAllSuggestions() {
  const res = await fetch(`${REACT_APP_API || ""}/api/custom/suggestions`);
  return await res.json();
}

// Suppression en lot des suggestions sélectionnées
export async function deleteSuggestions(ids) {
  const res = await fetch(`${REACT_APP_API || ""}/api/custom/suggestions/delete`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ids }),
  });
  if (!res.ok) throw new Error(`Suppression échouée (${res.status})`);
  return await res.json();
}

// Export des suggestions sélectionnées : "xml" / "csv" (FranceTerme) / "csv-std" (CSV classique)
export async function exportSuggestions(ids, format = "xml") {
  const paths = { xml: "export", csv: "export-csv", "csv-std": "export-csv-std" };
  const path = paths[format] || "export";
  const res = await fetch(`${REACT_APP_API || ""}/api/custom/suggestions/${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ids }),
  });
  if (!res.ok) throw new Error(`Export échoué (${res.status})`);
  return await res.blob();
}
export const updateSuggestion = async (id, data) => {
    await fetch(`${API_URL}/${id}`, {
        method: "PATCH", // ou "PUT" selon ton API Platform
        headers: {
            "Content-Type": "application/merge-patch+json",
            "Accept": "application/ld+json"
        },
        body: JSON.stringify(data),
    });
};

export async function addSuggestion(suggestion) {
    const res = await fetch(API_URL, {
        method: "POST",
        headers: {
            "Content-Type": "application/ld+json",
            "Accept": "application/ld+json"
        },
        body: JSON.stringify(suggestion),
    });
    return await res.json();
}

export async function deleteDomain(id) {
    return fetch(`${API_URL}/${id}`, { method: "DELETE" });
}
